// import parseTime, formatTime and set to filter
export { parseTime, parseTimeHI, parseTimeYMD, formatTime, filterKeys, toMoney, arabiaToSimplifiedChinese } from '@/utils';

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
    if(time === 1) {
        return time + label;
    }
    return time + label + 's';
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time);
    if(between < 3600) {
        return pluralize(~~(between / 60), ' minute');
    }else if(between < 86400) {
        return pluralize(~~(between / 3600), ' hour');
    }else {
        return pluralize(~~(between / 86400), ' day');
    }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
    const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'k' }
    ];
    for(let i = 0; i < si.length; i++) {
        if(num >= si[i].value) {
            return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
        }
    }
    return num.toString();
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousand(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * 10000 => "￥10,000"
 * @param {number} num
 */
export function toThousandMoney(num) {
    return '￥' + (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

// 去掉字符前后空格
export function toTrim(url) {
    return url.replace(/(^\s*)|(\s*$)/g, "");
}

// 字段值为null时显示无
export function strNull(str, txt) {
    if(str === null || str === "" || typeof str === "undefined") {
        return txt || "无";
    }else {
        return str;
    }
}

// 字符长度限制
export function strLimit(str, len = 10) {
    if(str && str.length > len) {
        return str.substr(0, len) + "...";
    }else {
        return str;
    }
}

export function toYuan(str) {
    if(str) {
        return str + ' 元';
    }
    return '';
}

export function toFixed(num, length) {
    if(typeof num == 'number') {
        return num.toFixed(length);
    }
    return num;
}

export function toSecond(str) {
    if(str) {
        return str + ' 秒';
    }
    return '';
}

export function join(str, str1) {
    if(str != null) {
        return str + str1;
    }
    return '';
}

export function append(baseString, appendString) {
    if(baseString == null) baseString = '';
    if(appendString == null) appendString = '';
    return baseString + appendString;
}

// 表格数据拼接
export function concatStr(array, defaultValue, connerStr = "/") {
    let temp = [];
    if(defaultValue != null) {
        temp = array.map(item => {
            if(item == null || item == "" || isNaN(item)) {
                item = defaultValue;
            }
            return item;
        });
    }else {
        temp = array.filter(item => {
            return typeof item != "undefined" && item != null && item != "";
        });
    }
    return temp.join(connerStr);
}

export function toNumber(str) {
    return Number(str) || 0;
}

export function toString(obj, separator) {
    if(Array.isArray(obj)) {
        return obj.join(separator || ',');
    }else if(typeof obj == 'object') {
        if(obj.toString) {
            return obj.toString();
        }
        return obj.join(separator || ',');
    }else if(typeof obj == 'undefined') {
        return '';
    }else {
        return '' + obj;
    }
}

export function slice(list, start, end) {
    return list.slice(start, end);
}
